import { useFormStoreDatasContext } from "../../../store/useFormStoreDatas";
import { useGoogleTag } from "../../../hooks/useGoogleTag";

export const Finish = ({ }: { }) => {
    useGoogleTag('FinalStep');
    const { formDatas } = useFormStoreDatasContext();

    const getCallMessage = (phoneNumber: string) => {
        const now = new Date();
        const day = now.getDay();
        const hours = now.getHours();

        if (day >= 1 && day <= 6 && hours < 9) {
            return `Votre demande est bien prise en compte. Un de nos agents vous appellera dans la matinée au <span class="text-primary font-medium">${phoneNumber}</span> pour vous accompagner dans le choix de votre nouvelle box internet. <strong>Ne manquez pas cette opportunité, soyez prêt à décrocher !</strong>`;
        }

        if (day >= 1 && day <= 5 && (hours > 19)) {
            return `Votre demande est bien prise en compte. Un de nos agents vous appellera dès demain matin au <span class="text-primary font-medium">${phoneNumber}</span> pour vous accompagner dans le choix de votre nouvelle box internet. <strong>Ne manquez pas cette opportunité, soyez prêt à décrocher !</strong>`;
        }

        if ((day === 6 && hours >= 16)) {
            return `Notre centre d'appels n'est pas ouvert pour le moment. Rassurez-vous, votre demande à bien été prise en compte. Un conseiller exclusif fibre <strong>vous appellera dès lundi matin</strong> sur le <span class="text-primary font-medium">${phoneNumber}</span> pour vous présenter les <strong>détails</strong> de l'offre et <strong>répondre à toutes vos questions.</strong><br /> <p>🌐 Ne manquez pas cette opportunité : Fibre à très grande vitesse à des prix jamais vus. <strong>Soyez prêt à décrocher !</strong></p> `;
        }

        if (day === 0) {
            return `Notre centre d'appels n'est pas ouvert le dimanche. Rassurez-vous, votre demande à bien été prise en compte. Un conseiller exclusif fibre <strong>vous appellera dès lundi matin</strong> sur le <span class="text-primary font-medium">${phoneNumber}</span> pour vous présenter les <strong>détails</strong> de l'offre et <strong>vous expliquer comment en profiter.</strong><br /> <p>🌐 Ne manquez pas cette opportunité : La Fibre à très grande vitesse à des prix jamais vus. <strong>Soyez prêt à décrocher en toute confiance !</strong></p> `;
        }

        return `       
        <ul class='font-bold flex flex-col gap-2 mt-4'>
          <li>✅ Un seul appel, plusieurs offres comparées</li>
          <li>✅ Un conseiller dédié pour vous accompagner</li>
          <li>✅ La garantie de réduire vos factures</li>
        </ul>
        `;
    };

    return (
        <>
            <div className="">
                <div className="flex flex-col items-center justify-center gap-5 lg:-mt-2">
                    <h2 className="text-xl text-center text-stone-700 px-2 lg:px-4 font-bold">Un de nos agents vous appelle dans <strong className="text-primaryNewComparateurFibre">1 min 30 sec</strong> : pour vous aider à choisir <strong className="text-primaryNewComparateurFibre">l’offre Fibre et Mobile la plus avantageuse</strong>.</h2>

                    <p className="text-center lg:text-sm px-2 bg-white text-black w-[95%] mx-auto lg:w-full rounded-lg pb-4 md:pb-8" dangerouslySetInnerHTML={{ __html: getCallMessage(formDatas.phone ?? "") }}></p>
                </div>
            </div>
        </>
    );
};
